/**
 * Files module
 * Utility functions for working with files (icons, readable names, etc.)
 */

import { safeExecute } from '../core/error-handler.js';

/**
 * Maps MIME content-type to Font Awesome icon
 * @param {string} contentType - MIME content type
 * @returns {string} CSS classes for Font Awesome icon
 */
export function getIconForContentType(contentType) {
    return safeExecute(
        () => {
            if (!contentType) return 'fas fa-file';
            const ct = contentType.toLowerCase();
            if (ct.indexOf('pdf') !== -1) return 'fas fa-file-pdf text-danger';
            if (
                ct.indexOf('word') !== -1 ||
                ct.indexOf('msword') !== -1 ||
                ct.indexOf('officedocument.word') !== -1
            )
                return 'fas fa-file-word text-primary';
            if (ct.indexOf('excel') !== -1 || ct.indexOf('spreadsheet') !== -1)
                return 'fas fa-file-excel text-success';
            if (ct.indexOf('powerpoint') !== -1 || ct.indexOf('presentation') !== -1)
                return 'fas fa-file-powerpoint text-warning';
            if (ct.indexOf('image') === 0) return 'fas fa-file-image text-info';
            if (ct.indexOf('text') === 0) return 'fas fa-file-alt';
            if (
                ct.indexOf('zip') !== -1 ||
                ct.indexOf('compressed') !== -1 ||
                ct.indexOf('tar') !== -1 ||
                ct.indexOf('rar') !== -1
            )
                return 'fas fa-file-archive';
            if (ct.indexOf('audio') === 0) return 'fas fa-file-audio';
            if (ct.indexOf('video') === 0) return 'fas fa-file-video';
            return 'fas fa-file';
        },
        'Files.getIconForContentType',
        'fas fa-file'
    );
}

/**
 * Converts MIME content-type to readable file type name
 * @param {string} contentType - MIME content type
 * @returns {string} Readable file type name in Czech
 */
export function getReadableFileType(contentType) {
    return safeExecute(
        () => {
            if (!contentType) return 'Soubor';
            const ct = contentType.toLowerCase();
            if (ct.indexOf('pdf') !== -1) return 'PDF dokument';
            if (
                ct.indexOf('word') !== -1 ||
                ct.indexOf('msword') !== -1 ||
                ct.indexOf('officedocument.word') !== -1
            )
                return 'Word dokument';
            if (ct.indexOf('excel') !== -1 || ct.indexOf('spreadsheet') !== -1)
                return 'Excel tabulka';
            if (ct.indexOf('powerpoint') !== -1 || ct.indexOf('presentation') !== -1)
                return 'PowerPoint prezentace';
            if (ct.indexOf('image') === 0) return 'Obrázek';
            if (ct.indexOf('text') === 0) return 'Textový soubor';
            if (
                ct.indexOf('zip') !== -1 ||
                ct.indexOf('compressed') !== -1 ||
                ct.indexOf('tar') !== -1 ||
                ct.indexOf('rar') !== -1
            )
                return 'Archiv';
            if (ct.indexOf('audio') === 0) return 'Zvukový soubor';
            if (ct.indexOf('video') === 0) return 'Video soubor';
            return 'Soubor';
        },
        'Files.getReadableFileType',
        'Soubor'
    );
}

export default { getIconForContentType, getReadableFileType };
